export const CO = {
  name: "AQMCS",
  full: "Assure Quality Management Certification Services",
  short: "AQMCS",
  tagline: "Audit · Certify · Excel",
  phone: "+91 92161 83238",
  email: "aqmcs@aqmcs.com",
  address: "1172 Sector 11 Panchkula, Haryana 134113",
  hours: "Mon–Sat: 9:00 AM – 5:30 PM",
};

export const SERVICES = [
  {
    icon: "🏭",
    tag: "ZED Assessment",
    title: "ZED Assessment",
    desc: "ZED Certification is a structured program for MSME implemented by Quality council of India. Focused on building awareness of Zero Defect Zero Effect. Scheme providing motivation and incentives for certification and fostering their transformation into globally competitive MSME Champions.",
  },
  {
    icon: "🍽️",
    tag: "Food Safety Audit",
    title: "Food Safety Audit",
    desc: "A Food Safety Audit evaluates hygiene, handling, storage, and compliance practices to ensure food is safe for consumption, meeting regulatory standards and improving overall operational quality.",
  },
  {
    icon: "🔍",
    tag: "Customized Third Party Audit",
    title: "Customized Third Party Audit",
    desc: "A Customized Third Party Audit is tailored to specific business needs, evaluating processes, compliance, and performance to provide independent, objective insights for improvement and risk reduction.",
  },
  {
    icon: "👥",
    tag: "Gender Equality Audit",
    title: "Gender Equality Audit",
    desc: "A Gender Equality Audit evaluates workplace policies, practices, and culture to identify gaps, promote fairness, ensure inclusivity, and strengthen equal opportunities for all employees.",
  },
  {
    icon: "🌿",
    tag: "Green Audit",
    title: "Green Audit",
    desc: "A Green Audit assesses an organization’s environmental impact, resource usage, and sustainability practices to identify improvements, ensure compliance, and promote eco-friendly, responsible operations.",
  },
  {
    icon: "📜",
    tag: "ISO Certification",
    title: "ISO Certification",
    desc: "ISO Certification verifies that an organization meets internationally recognized standards for quality, safety, efficiency, and compliance, enhancing credibility, customer trust, and overall business performance.",
  }
];

export const INDUSTRIES = [
  { e: "🏭", n: "Manufacturing" },
  { e: "🍎", n: "Food & Beverage" },
  { e: "💻", n: "Information Technology" },
  { e: "🏥", n: "Healthcare" },
  { e: "🚗", n: "Automotive" },
  { e: "🏗️", n: "Construction" },
  { e: "⚡", n: "Energy & Power" },
  { e: "📦", n: "Logistics" },
  { e: "🧪", n: "Pharmaceuticals" },
  { e: "🌾", n: "Agriculture" },
  { e: "🏨", n: "Hospitality" },
  { e: "📡", n: "Telecom" },
  { e: "🎓", n: "Education" },
  { e: "🏦", n: "Banking & Finance" },
  { e: "🛢️", n: "Oil & Gas" },
  { e: "⚙️", n: "Engineering" },
  { e: "🧵", n: "Textiles" },
  { e: "🚢", n: "Shipping & Ports" },
];

export const TEAM = [
  {
    init: "JC",
    name: "Joginder Chahal",
    role: "CEO & Lead Auditor",
    bio: "25+ years of experience in ISO certification and quality management systems across manufacturing and service sectors.",
  },
  {
    init: "PS",
    name: "Priya Sharma",
    role: "Food Safety Specialist",
    bio: "FSSAI & HACCP certified expert with deep experience in food industry compliance audits and regulatory consultancy.",
  },
  {
    init: "AM",
    name: "Arjun Mehta",
    role: "ISO Systems Expert",
    bio: "Certified lead auditor for ISO 9001, 14001 and 45001 with 200+ successful certifications across India.",
  },
  {
    init: "SV",
    name: "Sunita Verma",
    role: "ZED Program Head",
    bio: "Specialist in the ZED certification program, guiding MSMEs to quality excellence and government incentive eligibility.",
  },
  {
    init: "SV",
    name: "Sunita Verma",
    role: "ZED Program Head",
    bio: "Specialist in the ZED certification program, guiding MSMEs to quality excellence and government incentive eligibility.",
  },
];

export const TESTIMONIALS = [
  {
    stars: 5,
    q: "AQMCS helped us achieve ISO 9001 certification in record time. Their team was thorough, professional and incredibly supportive throughout — highly recommended.",
    name: "Vivek Jangra",
    co: "CEO, Greenth India",
  },
  {
    stars: 5,
    q: "The food safety audit was detailed and insightful. We identified critical gaps we hadn't noticed. Excellent expertise and follow-through from the entire team.",
    name: "Meena Gupta",
    co: "Quality Manager, FreshFoods Ltd",
  },
  {
    stars: 5,
    q: "Their ZED certification guidance helped us qualify for government subsidies. The ROI was tremendous. Best investment our company has made in quality systems.",
    name: "Anand Kapoor",
    co: "Owner, Kapoor Auto Parts",
  },
];

export const FAQS = [
  {
    q: "How long does ISO certification take?",
    a: "Typical ISO certification takes 3–6 months depending on organisation size, current compliance level and standard. Our gap analysis helps you get a precise timeline upfront.",
  },
  {
    q: "What is ZED Certification and who is eligible?",
    a: "ZED (Zero Defect Zero Effect) is a government scheme for Indian MSMEs to improve quality and reduce environmental impact. All registered MSMEs manufacturing goods are eligible to apply.",
  },
  {
    q: "Do you provide post-certification support?",
    a: "Yes. We offer ongoing support for maintaining compliance, conducting internal audits, and preparing for surveillance and recertification audits.",
  },
  {
    q: "Is training available for our internal team?",
    a: "Absolutely. We provide accredited in-house and online training for internal auditors, lead auditors, and management representatives across all major ISO standards.",
  },
  {
    q: "What industries do you serve?",
    a: "We serve 30+ industries including manufacturing, food & beverage, IT, healthcare, automotive, construction, logistics, pharmaceuticals and many more across India.",
  },
];

export const ISO_STANDARDS = [
  { e: "📋", std: "ISO 9001:2015", name: "Quality Management" },
  { e: "🌿", std: "ISO 14001:2015", name: "Environmental Management" },
  { e: "🦺", std: "ISO 45001:2018", name: "Occupational Health & Safety" },
  { e: "🍽️", std: "ISO 22000:2018", name: "Food Safety Management" },
  { e: "🔐", std: "ISO 27001:2022", name: "Information Security" },
  { e: "⚕️", std: "ISO 13485:2016", name: "Medical Devices" },
  { e: "⚡", std: "ISO 50001:2018", name: "Energy Management" },
  { e: "🚗", std: "IATF 16949:2016", name: "Automotive Quality" },
  { e: "🏗️", std: "ISO 21001:2018", name: "Educational Organisations" },
  { e: "🧪", std: "ISO 15189:2022", name: "Medical Laboratories" },
];
